// extracted by mini-css-extract-plugin
export default {"cardList":"AnalyticTryOnCards_cardList__-EyaT","card":"AnalyticTryOnCards_card__ZP0U6"};